/**
 * FileDropZone - reusable drag & drop file upload with image preview grid
 *
 * Usage:
 *   new FileDropZone({
 *     dropZone:  '#drop-zone',
 *     fileInput: '#photos-input',
 *     fileList:  '#file-list',
 *     allowedTypes:      ['image/jpeg', 'image/png', 'application/pdf'],  // optional
 *     allowedExtensions: ['jpg', 'jpeg', 'png', 'pdf'],                   // optional
 *     onFilesChanged: function(files) {}                                   // optional callback
 *   });
 */
var FileDropZone = function (options) {
    this.$dropZone  = $(options.dropZone);
    this.$fileInput = $(options.fileInput);
    this.$fileList  = $(options.fileList);

    this.allowedTypes      = options.allowedTypes      || ['image/jpeg', 'image/png', 'application/pdf'];
    this.allowedExtensions = options.allowedExtensions || ['jpg', 'jpeg', 'png', 'pdf'];
    this.alertMessage      = options.alertMessage      || 'Některé soubory byly vynechány. Jsou povoleny pouze formáty JPG, PNG a PDF.';
    this.maxFiles          = options.maxFiles          || 0;
    this.onFilesChanged    = options.onFilesChanged    || null;

    this.uploadedFiles = [];

    this._init();
};

FileDropZone.prototype._init = function () {
    var self = this;

    this.$dropZone.on('click', function (e) {
        if (e.target !== self.$fileInput[0]) {
            self.$fileInput.click();
        }
    });

    this.$fileInput.on('click', function (e) {
        e.stopPropagation();
    });

    this.$fileInput.on('change', function () {
        var filtered = self._filterFiles(this.files);
        if (filtered.length !== this.files.length) {
            alert(self.alertMessage);
        }
        self.uploadedFiles = self.uploadedFiles.concat(Array.from(filtered));
        self._enforceMaxFiles();
        self._syncInputFiles();
        self._renderGrid();
    });

    this.$dropZone.on('dragover', function (e) {
        e.preventDefault();
        e.stopPropagation();
        $(this).addClass('drag-over');
    });

    this.$dropZone.on('dragleave', function (e) {
        e.preventDefault();
        e.stopPropagation();
        $(this).removeClass('drag-over');
    });

    this.$dropZone.on('drop', function (e) {
        e.preventDefault();
        e.stopPropagation();
        $(this).removeClass('drag-over');

        var files    = e.originalEvent.dataTransfer.files;
        var filtered = self._filterFiles(files);

        if (filtered.length !== files.length) {
            alert(self.alertMessage);
        }

        self.uploadedFiles = self.uploadedFiles.concat(filtered);
        self._enforceMaxFiles();
        self._syncInputFiles();
        self._renderGrid();
    });
};

FileDropZone.prototype._enforceMaxFiles = function () {
    if (this.maxFiles > 0 && this.uploadedFiles.length > this.maxFiles) {
        this.uploadedFiles = this.uploadedFiles.slice(0, this.maxFiles);
        alert('Lze nahrát maximálně ' + this.maxFiles + ' souborů. Přebytečné soubory byly vynechány.');
    }
};

FileDropZone.prototype._filterFiles = function (files) {
    var self     = this;
    var filtered = [];

    $.each(files, function (i, file) {
        var ext = file.name.split('.').pop().toLowerCase();
        if (self.allowedTypes.includes(file.type) || self.allowedExtensions.includes(ext)) {
            filtered.push(file);
        }
    });

    return filtered;
};

FileDropZone.prototype._syncInputFiles = function () {
    var self = this;
    try {
        var dt = new DataTransfer();
        $.each(self.uploadedFiles, function (i, file) {
            dt.items.add(file);
        });
        self.$fileInput[0].files = dt.files;
    } catch (err) {
        console.error('FileDropZone: DataTransfer not supported', err);
    }

    if (typeof self.onFilesChanged === 'function') {
        self.onFilesChanged(self.uploadedFiles);
    }
};

FileDropZone.prototype._renderGrid = function () {
    var self       = this;
    var files      = this.uploadedFiles;
    var imageItems = [];

    this.$fileList.empty();
    if (files.length === 0) return;

    var $grid = $('<div class="file-preview-grid"></div>');

    $.each(files, function (i, file) {
        var $tile   = $('<div class="file-preview-tile"></div>');
        var $remove = $('<button type="button" class="file-preview-remove" title="Odebrat"><i class="fa fa-times"></i></button>');
        var $thumb  = $('<div class="file-preview-thumb"></div>');
        var $label  = $('<div class="file-preview-label"></div>').text(file.name);
        var $size   = $('<div class="file-preview-size"></div>').text(FileDropZone.formatSize(file.size));

        // Odstranění souboru
        (function (index) {
            $remove.on('click', function (e) {
                e.stopPropagation();
                self.uploadedFiles.splice(index, 1);
                self._syncInputFiles();
                self._renderGrid();
            });
        }(i));

        if (file.type === 'application/pdf') {
            $thumb.html('<i class="fa fa-file-pdf-o"></i>');
            $thumb.addClass('file-preview-thumb--file');
            imageItems.push(null);

            (function (f) {
                $thumb.on('click', function () {
                    var url = URL.createObjectURL(f);
                    window.open(url, '_blank');
                });
            }(file));
        } else {
            var reader     = new FileReader();
            var $img       = $('<img alt="">');
            var itemIndex  = imageItems.length;
            imageItems.push(null);

            (function (idx, $image, ii) {
                reader.onload = function (e) {
                    var src = e.target.result;
                    $image.attr('src', src);
                    imageItems[ii] = { src: src, type: 'image' };
                };

                $thumb.on('click', function () {
                    var galleryItems = [];
                    var startIndex   = 0;
                    $.each(imageItems, function (k, item) {
                        if (item) {
                            if (k === idx) startIndex = galleryItems.length;
                            galleryItems.push(item);
                        }
                    });
                    if (galleryItems.length === 0) return;
                    $.magnificPopup.open({
                        items: galleryItems,
                        type: 'image',
                        gallery: { enabled: true, navigateByImgClick: false },
                        image: { verticalFit: true }
                    }, startIndex);
                });
            }(i, $img, itemIndex));

            reader.readAsDataURL(file);
            $thumb.append($img);
            $thumb.addClass('file-preview-thumb--image');
        }

        $tile.append($remove).append($thumb).append($label).append($size);
        $grid.append($tile);
    });

    this.$fileList.append($grid);
};

FileDropZone.formatSize = function (bytes) {
    if (bytes === 0) return '0 Bytes';
    var k     = 1024;
    var sizes = ['Bytes', 'KB', 'MB', 'GB'];
    var i     = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
};

// Webpack wraps each imported file in its own module scope, so the top-level
// `var FileDropZone` is not global. Expose it for reclamation.js / vipBuyout.js.
window.FileDropZone = FileDropZone;
